import React, { useState, useRef, useEffect } from "react";
import "./AddOrganizationModal.css";

const AddOrganizationModal = ({ isOpen, onClose, onOrganizationCreated }) => {
  const [orgName, setOrgName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setOrgName("");
    setIsLoading(false);
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSubmit = () => {
    onOrganizationCreated({
      title: orgName,
      description: "organization",
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-org-modal-overlay">
      <div className="add-org-modal" ref={modalRef}>
        <button className="add-org-close-button" onClick={onClose} />
        <h1 className="add-org-modal-title">Добавить Организацию</h1>
        <div className="add-org-modal-content">
          <input
            className="add-org-input"
            type="text"
            placeholder="Название организации"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
        </div>
        <button
          onClick={handleSubmit}
          className="add-org-submit-button"
          disabled={isLoading || !orgName.trim()}
        >
          {isLoading ? "Загрузка..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default AddOrganizationModal;
